import { Mapper } from 'src/base/mapper'
import { ProductItemTypeEntity } from 'src/data/entities/product-item.entity'
import { ProductItemTypeModel } from 'src/domain/models/product-item.model'

export class ProductItemMapper extends Mapper<ProductItemTypeEntity, ProductItemTypeModel> {
	mapFrom(param: ProductItemTypeEntity): ProductItemTypeModel {
		return this.resultData(param)
	}

	mapTo(param: ProductItemTypeModel): ProductItemTypeEntity {
		return this.resultData(param)
	}

	resultData(param: ProductItemTypeEntity | ProductItemTypeModel) {
		return {
			productId: param.productId,
			itemCode: param.itemCode,
			itemDescription: param.itemDescription,
			isActive: param.isActive,
		}
	}
}
